module.exports = __webpack_public_path__ + "img/40_38_067_900.bd848a5e.jpg";